import * as HLF from "html-living-framework";
import {Anchor} from "../core/Anchor";
import {Ease} from "../core/Animatable";
import {Container} from "../core/Container";
import {Callback} from "../core/Reflection";
import {Sprite} from "../core/Sprite";
import {Assets} from "../data/Assets";
import {voOptionsDirections} from "../data/VoiceOver";
import {Keyboard} from "../gameobjects/Keyboard";
import {SplashPlayButton} from "../gameobjects/SplashPlayButton";
import {StartScreenLayout_main} from "../layout/StartScreenLayout";
import {Analytics} from "../managers/Analytics";
import {AudioChannel} from "../managers/AudioChannel";
import {VoiceOverManager} from "../managers/VoiceOverManager";

export class StartScreen extends HLF.LoadScreen {

    public static readonly NAME = "StartScreen";

    public readonly bg = this.addChild(new Sprite("background-splash", Anchor.middleCenter));
    public readonly main = this.addChild(new Container());
    public readonly loader = this.main.addChild(new Sprite());
    public readonly buttonPlay = this.main.addChild(new SplashPlayButton(undefined, () => this.onClickPlay()));

    private _onLoaded?: Callback;
    private _isAnimatedIn = false;

    public init(pSize: PIXI.Point) {
        super.init(pSize);

        StartScreenLayout_main.call(this);
        this.main.scale.set(0.5);

        this.loader.tweenTo(0.8, Ease.none, {
            rotation: -Math.PI * 2,
            repeat: -1,
        });
        this.loader.scaleFrom(0, 0.2, Ease.sineOut, () => {
            this.loader.delayedCall(0.4, () => {
                this._isAnimatedIn = true;
                this.showPlayButton();
            });
        });
        this.buttonPlay.visible = false;
        this.buttonPlay.hoverVO = "patw_ui11";
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);

        this.bg.height = this._size.y;
        this.bg.scale.x = this.bg.scale.y;
    }

    public onLoadComplete(pCallback: () => void): void {
        this._onLoaded = pCallback;
        StartScreenLayout_main.call(this);
        this.showPlayButton();

        AudioChannel.BGM.play(Assets.audio.bgm.menu.assetName, "loop");
    }

    private showPlayButton() {
        if (this._isAnimatedIn && this._onLoaded) {
            Analytics.event("startGame");
            this.loader.moveYTo(this._size.y + this.loader.height, 0.2, Ease.sineIn, () => {
                this.loader.visible = false;
                this.buttonPlay.visible = true;
                this.buttonPlay.moveYFrom(this._size.y + this.buttonPlay.height, 0.4, Ease.backOut, () => {
                    this.buttonPlay.pulse();
                });
                Keyboard.add(this.buttonPlay);
            });
        }
    }

    private onClickPlay() {
        this.interactiveChildren = false;
        Keyboard.enabled = false;
        this.buttonPlay.moveYTo(this._size.y + this.buttonPlay.height, 0.2, Ease.sineIn);
        VoiceOverManager.instance.playVO("patw_ui01", {
            ...voOptionsDirections,
            callback: this._onLoaded,
        });
    }
}
